export const EVENT_STAFF_ROLES = [
  ['co_teacher', 'Co-teacher'], ['observer', 'Observer'],
  ['class_support', 'Class support'], ['trainer', 'Trainer'],
  ['evaluator', 'Evaluator'], ['content', 'Content / filming'], ['other', 'Other staff'],
] as const;

export type EventStaffRole = typeof EVENT_STAFF_ROLES[number][0];
export type EventSupportingStaff = Record<string, { role: EventStaffRole; hourlyRate: number | null }>;

export function eventStaffRoleLabel(role?: string): string {
  return EVENT_STAFF_ROLES.find(([value]) => value === role)?.[1] || 'Co-teacher';
}

/** Only the assigned person's rate applies; substitutes do not inherit it. */
export function eventHourlyRate(staff: EventSupportingStaff | undefined, teacherId: string): number | null {
  const rate = staff?.[teacherId]?.hourlyRate;
  return typeof rate === 'number' && Number.isFinite(rate) && rate >= 0 ? rate : null;
}
